module.exports = function(mod) {
  var buttonOffsetTop = mod.offset().top;
  $(window).scroll(function(event) {
    var scrollTop = $(document).scrollTop()
    mod.toggleClass('fixed', scrollTop > buttonOffsetTop)
  });
}